/**
 * Determines if a given link is active based on the current location pathname.
 * IMPORTANT: This function & its implementations should be removed once there
 * are no more legacy paths with slugs instead of IDs.
 *
 * @param {Object} props
 * @param {string} [props.page] - The page to check if the link is active.
 * @param {string} props.candidateId - The candidate ID.
 * @param {string} props.candidateSlug - The candidate slug.
 * @returns {Function} A function intended to be passed to the `isActive` prop of `react-router-dom` links.
 *                     It takes `match` and `location` objects and returns a boolean indicating if the link is active.
 *
 * The function checks:
 * 1. If there is a match.
 * 2. If not, we check that the route is a candidate route, contains a valid ID or slug and the correct page.
 *    This is to also set the link as active when on a child slug route.
 */
export const getIsLinkActive =
  ({ page, candidateId, candidateSlug }) =>
  (match, location) => {
    const currentPathname = location.pathname

    if (match) return true

    // Split both paths into segments
    const currentSegments = currentPathname.split('/')

    // Confirm that the current route is a candidate route
    if (currentSegments[1] !== 'candidate') {
      return false
    }

    // Confirm that the current route contains a valid candidate ID or slug
    if (currentSegments[2] !== candidateId && currentSegments[2] !== candidateSlug) {
      return false
    }

    // Confirm that the current route contains the correct page
    return currentSegments[3] === page
  }
